import state from 'store/initialState'
import configureStore from 'store/configureStore'

export default configureStore(state)
